<template>
  <div class="input">
    <div class="input__name" v-if="$slots.default">
      <slot />
    </div>
    <div class="input__value">
      <slot name="field" v-bind:handlers="{onInput, onBlur, onFocus}">
        <textarea
          v-if="type == 'textarea'"
          class="input__field"
          v-bind="$attrs"
          v-model="propModel"
          :name="name"
          :placeholder="placeholderText"
          @blur="onBlur"
          @focus="onFocus"
          @input="onInput"
          ref="input"
        >
        </textarea>
        <input
          v-else
          class="input__field"
          v-bind="$attrs"
          v-model="propModel"
          :autocomplete="autocomplete"
          :disabled="disabled"
          :name="name"
          :placeholder="placeholderText"
          :required="required"
          :type="type"
          :value="val || propModel"
          @blur="onBlur"
          @focus="onFocus"
          @input="onInput"
          ref="input"
        />
      </slot>
    </div>
  </div>
</template>

<script>
  const emptyValidation = v => new Promise(success => success(true));
  const skipValidationKeyCodes = [9, 13, 16, 17];

  export default {
    name: "Input",
    data() {
      return {
        inputState: {
          validation: {
            actualId: 0,
            validatedValue: "",
            success: false,
          },
        },
      };
    },
    props: {
      val: String,
      modelValue: [Array, String, Number, Boolean],
      type: {
        type: String,
        default: 'text',
      },
      name: String,
      placeholderKey: String,
      validate: Function,
      validationDelay: Number,
      required: Boolean,
      autocomplete: String,
      disabled: Boolean,
    },
    computed: {
      placeholderText() {
        return this.placeholderKey ? this.$t(this.placeholderKey) : null;
      },
      propModel: {
        get() { return this.modelValue },
        set(value) {
          //this.$emit('update:modelValue', value)
        },
      },
    },
    methods: {
      onInput(ev) {
        //this.$emit("update:modelValue", ev.target.value);
        if (skipValidationKeyCodes.includes(ev.keyCode)) {
          return;
        }
        this.startValidation(this.validationDelay).catch(e => {});
      },
      onBlur() {
        this.$emit("blur");
        this.startValidation(0).catch(e => {});
      },
      onFocus() {
        this.$emit('focus');
      },
      startValidation(delay = 1000) {
        let inputState = this.inputState;
        inputState.validation.success = false;
        let validationId = ++inputState.validation.actualId;
        let input = this.$refs.input;
        input.setCustomValidity("");

        return new Promise((success, reject) => {
          const validationFn = () => {
            if (validationId != inputState.validation.actualId) {
              return reject();
            }
            (this.validate || emptyValidation)(input.value)
              .then(() => {
                if (validationId == inputState.validation.actualId) {
                  input.setCustomValidity("");
                  inputState.validation.validatedValue = input.value;
                  inputState.validation.success = true;
                  this.$emit("validate", true);
                  success(true);
                } else {
                  reject();
                }
              })
              .catch(error => {
                if (validationId == inputState.validation.actualId) {
                  input.setCustomValidity(error.message);
                  if (delay || inputState.validation.validatedValue != input.value) {
                    input.reportValidity();
                  }
                  inputState.validation.validatedValue = input.value;
                  this.$emit("validate", false);
                }
                success(false);
              })
          };
          delay ? setTimeout(validationFn, delay) : validationFn();
        });
      },
      isValid() {
        return this.inputState.validation.success;
      },
      focus() {
        this.$refs.input.focus();
      }
    }
  }
</script>
